var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.888 1.00037H3.111C1.94513 1.00037 1 1.94549 1 3.11136V17.8883C1 19.0542 1.94513 19.9993 3.111 19.9993H17.888C19.0538 19.9993 19.999 19.0542 19.999 17.8883V3.11136C19.999 1.94549 19.0538 1.00037 17.888 1.00037Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8059 8.38775C7.68031 8.38775 8.38915 7.6789 8.38915 6.8045C8.38915 5.9301 7.68031 5.22125 6.8059 5.22125C5.9315 5.22125 5.22266 5.9301 5.22266 6.8045C5.22266 7.6789 5.9315 8.38775 6.8059 8.38775Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9983 13.667L14.7208 8.38953L3.11035 20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonImg1);
export default __webpack_public_path__ + "static/media/button-img-1.56433348d3b7d9085a61c51b1aaa62ac.svg";
export { ForwardRef as ReactComponent };